import React, { Component } from "react"
import PropTypes from "prop-types"
import { Radium } from "higher-order-components"
import { childParser } from "containers/utilities"
import { Overlay } from "containers"
import { Portal } from "react-portal"

class TriggeredOverlay extends Component {
  constructor() {
    super()
    this.state = {
      overlayActive: false
    }
  }
  activateOverlay(active) {
    this.setState({ overlayActive: active })
  }
  render() {
    const { trigger } = this.props
    const { overlayActive } = this.state
    const triggerProps = { components: [trigger] }
    return (
      <div style={{
        display: "flex",
        justifyContent: "center"
      }}>
        {childParser(triggerProps, () => ({
          onClick: (event) => {
            if (event) event.preventDefault()
            this.activateOverlay(true)
          }
        }))}
        {overlayActive && (
          <Portal>
            <Overlay close={() => this.activateOverlay(false)}>{childParser(this.props, () => ({overlay: true}))}</Overlay>
          </Portal>
        )}
      </div>
    )
  }
}
TriggeredOverlay.propTypes = {
  trigger: PropTypes.object,
  components: PropTypes.array,
  children: PropTypes.node
}

export default Radium(TriggeredOverlay)



// WEBPACK FOOTER //
// ./src/containers/triggered-overlay/index.jsx